import { Entity } from "./Entity";

export class UploadCarga extends Entity {
  id = 0;

  constructor() {
    super();
  }

  fileBase64: File;
  loadTypesId;
}
